import { render, staticRenderFns } from "./quagga-barcode-scanner.vue?vue&type=template&id=e2916d84"
import script from "./quagga-barcode-scanner.vue?vue&type=script&lang=js"
export * from "./quagga-barcode-scanner.vue?vue&type=script&lang=js"
import style0 from "./quagga-barcode-scanner.vue?vue&type=style&index=0&id=e2916d84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports